export enum DeviceShippingOption {
    ShipToHome = 'shipToHome',
    StorePickUp = 'storePickUp',
    InStock = 'inStock',
}

export interface PickupStore {
  Id: string;
  Name: string;
  Address: string;
  City: string;
  State: string;
  Zipcode: string;
  Distance: string;
  EstMinDate: string;
  EstMaxDate: string;
  EstMinTime: string;
  EstMaxTime: string;
  StoreOpen: string;
  StoreClose: string;
  AvailabilityToken: string;
}

export interface LevelOfService {
  Preferred: string;
  Name: string;
  Price: string;
  PriceAfterOffers: string;
  EstMinArrivalDate: string;
  EstMaxArrivalDate: string;
  AvailabilityToken: string;

}